import React from "react";
import { Row, Col } from "reactstrap";

const SimpleLoader = () => {
  return (
    <Row
      className="align-items-md-center"
      style={{ textAlign: "center", margin: "15px 0" }}
    >
      <Col xl={12}>
        <div className="spinner-border text-primary m-1" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </Col>
    </Row>
  );
};

export default SimpleLoader;
